{
  "reports": {
    "navigation_title": "Informes",
    "create_new": "Nuevo Informe",
    "devices": "Dispositivos",
    "common_parameters": {
      "title": "Seleccionar en varios dispositivos",
      "devices": "%{count}/%{total} dispositivos"
    },
    "floor_negative_deltas": "Limitar deltas negativos a cero",
    "floor_negative_deltas_tooltip": "Cuando está activado, un delta de sotavento − barlovento inferior a cero (la lectura de barlovento es mayor que la de sotavento) se informa como cero para los parámetros de concentración. Los parámetros con signo, como la presión diferencial y la temperatura, nunca se limitan.",
    "aggregate": "Agregación",
    "aggregation_info": {
      "subheader": "Cómo se agrupan las mediciones antes de que el informe las evalúe",
      "metrics_warning": "Los parámetros estadísticos como un promedio móvil de 15 minutos ya se promedian sobre su propio periodo. La agregación los vuelve a promediar y oculta los picos cortos.",
      "intro": "Define si las mediciones se usan tal como se registraron o se promedian en intervalos fijos.",
      "none_title": "Ninguno",
      "none": [
        "Las mediciones se usan tal como se registraron, por lo que los picos cortos siguen visibles.",
        "Periodos largos o muchos dispositivos pueden ser demasiado grandes para generarse; en ese caso, acorte el rango o elija un intervalo."
      ],
      "intervals_title": "Intervalos: %{intervals}",
      "intervals": [
        "Cada intervalo muestra la media aritmética de sus mediciones.",
        "Promediar suaviza el ruido y acorta los informes, pero oculta los picos más cortos que el intervalo.",
        "**Aplicar un intervalo a parámetros estadísticos como AVG (promedio móvil) los vuelve a promediar.**"
      ],
      "types": {
        "aethair_cms_2567": {
          "title": "Informes CMS-2567",
          "items": [
            "Un intervalo que no cumple cuenta con toda su duración en la duración de la infracción.",
            "El tiempo sin conexión se estima a partir de los intervalos faltantes; sin agregación se asumen mediciones de 1 minuto."
          ]
        }
      }
    },
    "title": "Informes",
    "new_title": "Crear Informe",
    "edit_title": "Editar Informe",
    "view_title": "Ver Informe",
    "analytics_title": "Analizar Informe",
    "common": "Información del lugar",
    "name": "Nombre",
    "description": "Descripción",
    "phone": "Teléfono",
    "address": "Dirección",
    "place_picture": "Imagen del lugar",
    "download_csv": "Descargar CSV",
    "download_xlsx": "Descargar Excel",
    "scheduled_daily": "Programado Diariamente",
    "scheduled_weekly": "Programado Semanalmente",
    "job_statuses": {
      "html_upload_failed": "Error al subir HTML",
      "pdf_upload_failed": "Error al subir PDF",
      "email_delivery_failed": "Error en la entrega del correo electrónico",
      "generic_failed": "%{key} falló"
    },
    "assets_statuses": {
      "preparing_title": "Preparando tu informe…",
      "preparing_sub": "Esto suele tardar menos de un minuto. Puedes salir de esta página — la generación continúa en segundo plano.",
      "title_ready": "Tu informe está listo",
      "title_one_failed": "Un archivo no se pudo generar",
      "title_some_failed": "Algunos archivos no se pudieron generar",
      "csv": "CSV",
      "html": "HTML",
      "pdf": "PDF",
      "noesis_summary": "Resumen de Noesis",
      "in_progress": "En progreso",
      "error_csv": "Error al exportar CSV",
      "error_html": "Error al subir HTML",
      "error_pdf": "Error al subir PDF",
      "error_noesis": "Error al generar el resumen",
      "scheduled_next_run_text": "La próxima ejecución del informe está programada para %{date} (%{timezone}).",
      "scheduled_waiting_text": "El informe está programado. Vuelve a comprobar más tarde.",
      "next_run_at": "La próxima ejecución del informe está programada para %{date} (%{timezone}).",
      "scheduled": {
        "first_run_title": "El primer informe se ejecuta",
        "frequency_label": "Frecuencia",
        "range_label": "Rango de tiempo",
        "range_daily": "Últimas 24 horas",
        "range_weekly": "Últimos 7 días",
        "recipients_label": "Destinatarios",
        "no_recipients": "—"
      }
    },
    "wind_detection_types": {
      "auto": "Automático",
      "manual": "Manual"
    },
    "device_type": {
      "upwind": "A barlovento",
      "downwind": "A sotavento"
    },
    "dialogs": {
      "delete": {
        "title": "¿Está seguro?",
        "content": "¿Está seguro de que desea eliminar el informe '%{name}'? No puede deshacer esta acción"
      }
    },
    "edit_details_breadcrumb": "Editar",
    "configuration_breadcrumb": "Configuración",
    "view_details_breadcrumb": "Ver",
    "analytics_details_breadcrumb": "Analítica",
    "parameter_mixed_units": "Todos los parámetros de esta fila deben usar la misma unidad (seleccionadas: %{units})",
    "rolling": {
      "mixed_types": "Sin agregación seleccione parámetros estadísticos AVG (promedio móvil) u otros parámetros, no ambos",
      "mixed_periods": "Todos los parámetros estadísticos deben usar el mismo periodo de promedio (seleccionados: %{periods} min)"
    },
    "perimeter_validation": {
      "single_device": "Seleccione este parámetro en al menos dos dispositivos para comparar barlovento y sotavento",
      "missing_wind_types": "Seleccione este parámetro también en el lado %{types}"
    },
    "perimeter_custom": {
      "info": {
        "subheader": "Monitoreo de perímetro personalizado con sus propios niveles de alerta",
        "description": "Compara las lecturas a sotavento con las de barlovento (fondo) usando los parámetros y niveles de alerta que usted elija. Úselo para límites específicos del sitio, otras normativas (por ejemplo SCAQMD Rule 1467, COV 0.5 ppm) u objetivos internos.",
        "setup": {
          "parameters_title": "Parámetros",
          "parameters": [
            "Seleccione el mismo parámetro en los dispositivos de barlovento y sotavento que desee comparar: canales de sensor sin procesar o parámetros estadísticos.",
            "Sin agregación, seleccione parámetros estadísticos AVG (promedio móvil) con un mismo periodo u otros parámetros, no ambos.",
            "Opcionalmente, agregue uno o dos niveles de alerta, cada uno con un operador y un valor. Los parámetros sin niveles se informan sin resaltado ni periodos de alerta.",
            "Los valores y niveles de alerta usan la unidad y la precisión de los parámetros seleccionados."
          ],
          "wind_title": "Viento",
          "wind": [
            "Con agregación, el viento se promedia por intervalo y barlovento y sotavento se eligen por intervalo.",
            "Sin agregación, el viento se promedia cada minuto sobre el periodo AVG (promedio móvil) o 15 minutos (al menos 3 lecturas); con viento en calma (menos de 0.5 m/s) se mantiene la selección anterior."
          ]
        },
        "calculation": {
          "intro": "La evaluación depende del tipo de parámetro y de la agregación.",
          "types_title": "Por tipo de parámetro",
          "raw_title": "Canales de sensor sin procesar",
          "raw": [
            "Con agregación: las lecturas de cada intervalo se promedian en un valor por dispositivo.",
            "Sin agregación: las lecturas se evalúan cada minuto tal como se registraron. Cada fila de la tabla cubre un intervalo de reporte y muestra sus últimas lecturas. El viento se promedia durante los 15 minutos anteriores.",
            "Ideal para detectar picos cortos, aunque las lecturas pueden tener ruido y los periodos largos generan tablas largas (600 filas para un día de 10 horas con reporte cada minuto)."
          ],
          "avg_title": "Parámetros estadísticos AVG (promedio móvil)",
          "avg": [
            "Un promedio móvil que se recalcula cada minuto sobre su periodo, por ejemplo un promedio móvil de 15 minutos.",
            "Con agregación: los promedios móviles de cada intervalo se vuelven a promediar, lo que suaviza aún más los picos.",
            "Sin agregación: se evalúa cada minuto tal cual. Cada fila de la tabla cubre un periodo y muestra su último promedio móvil (el valor de las 09:59 en la fila de las 09:45). Todos los parámetros estadísticos AVG (promedio móvil) deben compartir un periodo, que también define la ventana de viento."
          ],
          "other_title": "Otros parámetros estadísticos (MIN, MAX, ABS, DIFF)",
          "other": [
            "Con agregación: sus valores de cada intervalo se promedian, por lo que MAX 15 min da la media de sus máximos móviles, no el valor más alto del intervalo.",
            "Sin agregación: se usan tal como se registraron, igual que los canales de sensor sin procesar."
          ],
          "steps_title": "Pasos de evaluación",
          "aggregated_title": "Con agregación",
          "steps": [
            "Cada parámetro se promedia por intervalo y dispositivo.",
            "Los valores de barlovento (fondo) y sotavento se toman por intervalo, según la detección de viento.",
            "Delta = sotavento − barlovento. Con \"Limitar deltas negativos a cero\" activado, un delta negativo cuenta como 0.",
            "Los intervalos cuyo delta supera un nivel de alerta se resaltan: en ámbar para el nivel de alerta 1 de dos, en rojo para el nivel de alerta 2 o un nivel único. Los intervalos consecutivos que lo superan forman un periodo de alerta con su inicio, duración y delta máximo."
          ],
          "rolling_title": "Sin agregación",
          "rolling_steps": [
            "Cada minuto se toma el valor de cada parámetro por dispositivo: el promedio móvil o la lectura registrada.",
            "Los valores de barlovento (fondo) y sotavento se toman por minuto, según la detección de viento.",
            "Delta = sotavento − barlovento. Con \"Limitar deltas negativos a cero\" activado, un delta negativo cuenta como 0.",
            "Los minutos consecutivos que superan el nivel forman un periodo de alerta con su inicio, duración y delta máximo.",
            "Las filas de la tabla se resaltan cuando su delta supera un nivel de alerta (en ámbar para el nivel de alerta 1 de dos, en rojo para el nivel de alerta 2 o un nivel único); los periodos de alerta más cortos dentro de una fila aparecen en la Evaluación de Impacto."
          ]
        }
      }
    },
    "alert_levels": {
      "add": "Agregar nivel de alerta",
      "add_level": "Agregar nivel de alerta %{index}",
      "level": "Nivel de alerta %{index}",
      "name": "Nombre",
      "value": "Valor",
      "errors": {
        "required": "Obligatorio",
        "number": "Debe ser un número",
        "positive": "Debe ser mayor que 0",
        "higher": "Debe ser mayor que el nivel de alerta %{index}",
        "lower": "Debe ser menor que el nivel de alerta %{index}"
      }
    },
    "perimeter_standard": {
      "metrics_label": "Promedios móviles de 15 minutos",
      "no_metrics": "No hay parámetros estadísticos de promedio móvil de 15 minutos de %{pollutant} en los dispositivos seleccionados",
      "missing_wind_types": "Seleccione también un parámetro estadístico del lado %{types}",
      "mixed_units": "Todos los parámetros estadísticos de esta fila deben usar la misma unidad (seleccionados: %{units})",
      "pollutants": {
        "pm10": "Partículas (PM10)",
        "voc": "Vapores orgánicos (COV)"
      },
      "additional_parameter": "Parámetro adicional",
      "other_parameters": "otros",
      "add_parameter": "Agregar parámetro",
      "pollutant_names": {
        "pm10": "Partículas",
        "voc": "Vapores orgánicos"
      },
      "pollutant_titles": {
        "pm10": "Partículas",
        "voc": "Vapores orgánicos (COV)"
      }
    },
    "der10": {
      "info": {
        "issued": "Publicado el %{date} por el Departamento de Conservación Ambiental del Estado de Nueva York, División de Remediación Ambiental.",
        "description": "Los apéndices 1A (Plan Genérico de Monitoreo del Aire Comunitario del NYSDOH) y 1B exigen monitoreo en tiempo real de COV y PM10 en el perímetro a sotavento durante los trabajos intrusivos. Los niveles a sotavento se comparan con los de barlovento (fondo) como promedios de 15 minutos; las superaciones exigen supresión de polvo, una pausa o la detención de los trabajos.",
        "open_pdf": "Abrir DER-10 (PDF)",
        "tabs": {
          "overview": "Resumen",
          "setup": "Configuración",
          "calculation": "Cálculo"
        },
        "setup": {
          "parameters_title": "Parámetros",
          "parameters": [
            "Solo se aceptan promedios móviles de 15 minutos: de un canal PM10 o COV, o de un canal \"Mass Conc. Total\" de DustTrak con entrada PM10.",
            "Cree uno por dispositivo y contaminante en la página del dispositivo: Agregar parámetro estadístico → Función: Promedio, Periodo: 15 min, Parámetro: PM10 (o COV).",
            "Se calculan desde el momento en que se crean, así que créelos antes de iniciar los trabajos intrusivos.",
            "Selecciónelos en todos los dispositivos del informe. PM10 por sí solo es válido; COV es opcional.",
            "Las filas de PM10 y COV se completan con los niveles de DER-10. Puede cambiarlos y definir uno o dos niveles de alerta por fila.",
            "Agregue parámetros para otros promedios móviles de 15 minutos (por ejemplo H₂S) con sus propios niveles de alerta.",
            "Los niveles se comparan con las lecturas en la unidad de los parámetros, que se muestra junto a cada nivel. DER-10 expresa sus niveles en µg/m³ (PM10) y ppm (COV): ajústelos para parámetros en otra unidad (100 µg/m³ = 0.1 mg/m³, 5 ppm = 5000 ppb). Todos los parámetros de una fila deben usar la misma unidad."
          ],
          "wind_title": "Viento",
          "wind": [
            "Detección automática del viento: seleccione los canales directos de Velocidad del viento y Dirección del viento (°). El viento se promedia en los mismos 15 minutos (al menos 3 lecturas); con viento en calma (menos de 0.5 m/s) se mantiene la selección anterior.",
            "Detección manual del viento: cada contaminante necesita un parámetro estadístico a barlovento y otro a sotavento, según la disposición fija de estaciones que describe DER-10."
          ]
        },
        "calculation": {
          "intro": "El informe evalúa cada minuto del periodo:",
          "steps": [
            "Cada parámetro estadístico proporciona un promedio móvil de 15 minutos, actualizado cada minuto.",
            "Los valores de barlovento (fondo) y sotavento se toman por minuto, según la detección de viento.",
            "Delta = sotavento − barlovento. Los deltas negativos (barlovento mayor que sotavento) se informan tal como se miden.",
            "El delta se compara con los niveles de alerta de cada fila. Los valores predeterminados de DER-10 son PM10 ≥ 100 µg/m³ (supresión de polvo) y > 150 µg/m³ (detener los trabajos); COV > 5 ppm (pausa) y > 25 ppm (detención).",
            "Los minutos consecutivos por encima de un nivel forman una superación, con su inicio, fin, duración y delta máximo.",
            "La tabla de datos tiene una fila cada 15 minutos con el promedio móvil del último minuto (el valor de las 09:59 en la fila de las 09:45). Las superaciones más cortas aparecen en la Evaluación de Impacto.",
            "Los minutos sin datos de ambos lados no se evalúan."
          ]
        }
      },
      "level_names": {
        "pm10": [
          "Aplicar supresión de polvo",
          "Detener los trabajos y reevaluar"
        ],
        "voc": [
          "Pausar los trabajos",
          "Detención"
        ]
      },
      "level_info": {
        "pm10": [
          "DER-10: aplicar supresión de polvo a ≥ 100 µg/m³ sobre barlovento",
          "DER-10: detener los trabajos y reevaluar a > 150 µg/m³ sobre barlovento"
        ],
        "voc": [
          "DER-10: pausar los trabajos a > 5 ppm sobre el fondo",
          "DER-10: detención a > 25 ppm sobre el fondo"
        ]
      }
    },
    "nj_pam": {
      "info": {
        "issued": "Versión 1.0, publicada en %{date} por el Departamento de Protección Ambiental de Nueva Jersey, Remediación y Reurbanización de Sitios Contaminados.",
        "description": "N.J.A.C. 7:26E-5.5(b)7 exige un plan de monitoreo del aire perimetral para acciones de remediación de más de 20 días laborables. PM10 y COV totales se monitorean en tiempo real en el perímetro como promedios ponderados en el tiempo de 15 minutos y se comparan con niveles de respuesta específicos del sitio obtenidos con la calculadora PAM del NJDEP. Las superaciones de 15, 30, 45 y 60 minutos exigen verificaciones, controles de emisiones, muestreo de confirmación y la detención de los trabajos.",
        "open_pdf": "Abrir la guía técnica PAM (PDF)",
        "setup": {
          "parameters_title": "Parámetros",
          "parameters": [
            "Solo se aceptan promedios móviles de 15 minutos: de un canal PM10 o COV, o de un canal \"Mass Conc. Total\" de DustTrak con entrada PM10.",
            "Cree uno por dispositivo y contaminante en la página del dispositivo: Agregar parámetro estadístico → Función: Promedio, Periodo: 15 min, Parámetro: PM10 (o COV).",
            "Se calculan desde el momento en que se crean, así que créelos antes de iniciar los trabajos que generan emisiones.",
            "PM10 se completa con 150, el NAAQS de PM10 de 24 horas en µg/m³. Introduzca un nivel de respuesta específico del sitio más bajo si el plan PAM lo exige; no debería superar 150 µg/m³.",
            "Introduzca el nivel de respuesta de COVT específico del sitio (ppb) del plan PAM: la guía no tiene un valor predeterminado.",
            "Agregue parámetros para monitores específicos de sustancias (por ejemplo vapor de mercurio o H₂S) y use su HBTV como nivel de alerta.",
            "Los niveles se comparan con las lecturas en la unidad de los parámetros, que se muestra junto a cada nivel: ajuste el nivel de PM10 para parámetros en otra unidad (150 µg/m³ = 0.15 mg/m³). Todos los parámetros de una fila deben usar la misma unidad."
          ],
          "wind_title": "Viento",
          "wind": [
            "La guía exige velocidad y dirección del viento del propio sitio; las estaciones meteorológicas públicas no pueden ser la única fuente.",
            "Detección automática del viento: seleccione los canales directos de Velocidad del viento y Dirección del viento (°). El viento se promedia en los mismos 15 minutos (al menos 3 lecturas); con viento en calma (menos de 0.5 m/s) se mantiene la selección anterior.",
            "Detección manual del viento: cada contaminante necesita al menos un parámetro estadístico a barlovento y otro a sotavento."
          ]
        },
        "calculation": {
          "intro": "El informe evalúa cada intervalo de monitoreo de 15 minutos del periodo:",
          "steps": [
            "Cada parámetro estadístico proporciona un promedio móvil de 15 minutos, actualizado cada minuto. El promedio del último minuto de un intervalo (p. ej., 09:59 para 09:45–09:59) es el promedio ponderado en el tiempo del intervalo.",
            "Los valores de barlovento (fondo) y sotavento se toman en ese minuto, según la detección de viento.",
            "Delta = sotavento − barlovento (contribución del sitio). Los deltas negativos (barlovento mayor que sotavento) se informan tal como se miden.",
            "El delta se compara con los niveles de alerta de cada fila.",
            "Los intervalos consecutivos por encima de un nivel forman una superación, con su inicio, fin, duración, delta máximo y el paso de respuesta alcanzado: 1 (15 min) verificar los instrumentos e identificar la fuente, 2 (30 min) aplicar controles de vapores y polvo, 3 (45 min) modificar las operaciones y tomar una muestra confirmatoria, 4 (60 min) detener los trabajos que generan emisiones.",
            "La tabla de datos tiene una fila por intervalo con su promedio.",
            "Los intervalos sin datos de ambos lados en sus últimos minutos no se evalúan."
          ]
        }
      },
      "level_names": {
        "pm10": [
          "Nivel de respuesta"
        ],
        "voc": [
          "Nivel de respuesta"
        ]
      },
      "level_info": {
        "pm10": [
          "Nivel de respuesta NJDEP PAM: 150 µg/m³ (NAAQS de PM10 de 24 horas) o menos"
        ],
        "voc": [
          "Nivel de respuesta NJDEP PAM: específico del sitio, en ppb"
        ]
      },
      "level_hints": {
        "pm10": "Predeterminado: 150, el NAAQS de PM10 de 24 horas en µg/m³; use un nivel de respuesta específico del sitio más bajo cuando la calculadora PAM lo indique.",
        "voc": "Introduzca el nivel de respuesta de COVT del plan PAM del sitio (calculado con la calculadora PAM del NJDEP). Solo es necesario si el sitio tiene contaminantes volátiles. Ejemplo de la guía: 629 ppb."
      }
    },
    "cms_2567_report": {
      "add_category_label": "Agregar categoría AECC",
      "all_categories_added": "Se han agregado todas las categorías AECC disponibles",
      "subcategories_title": "Subcategorías",
      "view_thresholds": "Ver umbrales",
      "no_threshold_data": "No hay datos de umbrales disponibles",
      "groups": {
        "aecc-100": {
          "label": "Cumplimiento de Humedad",
          "description": "Monitorear HR 20-60% en quirófano y áreas estériles"
        },
        "aecc-200": {
          "label": "Cumplimiento de Temperatura",
          "description": "Seguimiento de temperatura según ASHRAE 170"
        },
        "aecc-300": {
          "label": "Presión y Ventilación",
          "description": "Monitorear diferenciales de presión"
        },
        "aecc-400": {
          "label": "Calidad del Aire",
          "description": "Seguimiento de PM, VOC, niveles de CO₂"
        }
      }
    },
    "type_info": {
      "tooltip": "Más información sobre este tipo de informe",
      "air_quality": {
        "subheader": "Calidad del aire de los dispositivos seleccionados según un estándar",
        "description": "Muestra cómo se comportaron los dispositivos seleccionados frente a un estándar de calidad del aire. Cada parámetro obtiene un estado según los rangos del estándar, y los dispositivos obtienen un índice general de calidad del aire.",
        "sections": [
          {
            "title": "Estándar",
            "items": [
              "Los estándares predefinidos usan sus propios parámetros y rangos (bueno, moderado, malo).",
              "Personalizado: sus propios parámetros, operadores y niveles de alerta. Los parámetros se califican como Aprobado, Advertencia (nivel de alerta 1 de dos) o Fallido (nivel de alerta 2 o un nivel único), sin índice de calidad del aire."
            ]
          },
          {
            "title": "Vista",
            "items": [
              "Básica: Resumen por parámetro y Resumen por dispositivo, cuando al menos un parámetro tiene rangos.",
              "Extendida: añade Análisis por dispositivo, con un gráfico de líneas por parámetro y una tabla de datos con las mediciones de cada dispositivo. Los estándares personalizados siempre incluyen los gráficos; la tabla de datos requiere la vista Extendida."
            ]
          }
        ]
      },
      "perimeter_monitor": {
        "subheader": "Sotavento comparado con barlovento alrededor de una zona de trabajo",
        "description": "Compara las lecturas a sotavento con las lecturas a barlovento (fondo) para mostrar el impacto de los trabajos en el sitio. El delta (sotavento − barlovento) se compara con los niveles de alerta. Los periodos de alerta aparecen en la Evaluación de Impacto, junto con una tabla de datos y, con detección automática del viento, una rosa de los vientos.",
        "standard_title": "Estándar",
        "standard": [
          "Personalizado: sus propios parámetros, operadores y niveles de alerta."
        ],
        "standard_der10": "NYS DER-10: PM10 y COV sobre promedios móviles de 15 minutos, con los niveles de DER-10 predefinidos.",
        "standard_nj_pam": "NJDEP PAM: PM10 y COVT sobre promedios de 15 minutos con niveles de respuesta específicos del sitio.",
        "sections": [
          {
            "title": "Detección de viento: Automática",
            "items": [
              "Barlovento y sotavento se eligen a partir de la dirección del viento de la estación meteorológica y la ubicación de los dispositivos: el dispositivo más a barlovento es el fondo y el más a sotavento se compara con él.",
              "Seleccione los canales directos de Velocidad del viento y Dirección del viento (°); el informe los promedia.",
              "Requiere una estación meteorológica y al menos dos dispositivos con ubicación."
            ]
          },
          {
            "title": "Detección de viento: Manual",
            "items": [
              "Usted marca cada dispositivo como barlovento o sotavento; la asignación no sigue al viento.",
              "Los dispositivos a barlovento se promedian como fondo y los de sotavento como lectura a sotavento. Cada parámetro necesita ambos lados."
            ]
          },
          {
            "title": "Ubicación de los dispositivos",
            "items": [
              "Siempre se usa la ubicación configurada manualmente en el dispositivo.",
              "Si no la tiene, se usa la última ubicación registrada durante el periodo del informe para todo el informe. Si no hay ninguna, se usa la más reciente y el informe incluye el dispositivo en una nota.",
              "Los dispositivos sin ubicación no aparecen en el mapa ni se usan en la detección automática del viento."
            ]
          },
          {
            "title": "Limitar deltas negativos a cero",
            "items": [
              "Cuando está activado, un delta negativo (barlovento mayor que sotavento) se informa como cero para los parámetros de concentración. Los parámetros con signo, como la presión diferencial y la temperatura, nunca se limitan.",
              "Solo informes personalizados: los informes de estándar muestran los deltas negativos tal como se miden."
            ]
          }
        ]
      }
    },
    "settings": {
      "steps": {
        "report_type": "Tipo de Informe",
        "report_type_and_standard": "Tipo de Informe y Estándar",
        "devices_and_wind": "Dispositivos y Viento",
        "devices": "Dispositivos",
        "parameters_and_alert_levels": "Parámetros y Niveles de Alerta",
        "data_aggregation": "Agregación de Datos",
        "output": "Salida",
        "aecc_categories": "Categorías de Cumplimiento AECC"
      },
      "report_type": "Tipo de informe",
      "wind_detection": "Detección de viento",
      "weather_station": "Estación meteorológica",
      "wind_speed": "Velocidad del viento",
      "wind_direction": "Dirección del viento",
      "add_device": "Agregar dispositivo"
    }
  }
}
